import * as SeparatorPrimitive from "@radix-ui/react-separator";
import {
	type ComponentPropsWithoutRef,
	type ElementRef,
	forwardRef,
} from "react";
import { cn } from "../lib/cn";

export interface DividerProps
	extends ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> {}

const Divider = forwardRef<
	ElementRef<typeof SeparatorPrimitive.Root>,
	DividerProps
>(
	(
		{ className, orientation = "horizontal", decorative = true, ...props },
		ref,
	) => (
		<SeparatorPrimitive.Root
			ref={ref}
			decorative={decorative}
			orientation={orientation}
			className={cn(
				"shrink-0 bg-border",
				orientation === "horizontal"
					? "h-[1px] w-full my-4"
					: "h-full w-[1px] mx-4",
				className,
			)}
			{...props}
		/>
	),
);
Divider.displayName = "Divider";

export default Divider;
export { Divider };
